import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from '../routes';
import GlobalStyle from '../styles/global-style';
import { store } from './store/configureStore';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <Router>
        <Routes />
        <GlobalStyle />
      </Router>
    </Provider>
  );
};

export default App;
